<template>
  <div>
    <h2 class="step-name">Client Details</h2>

    <div class="step-section">
      <text-input
        label="The name of the client spoken to"
        field-name="client_consulter"
      >
      </text-input>

      <text-input label="Client Code" field-name="client_code" disabled> </text-input>

      <text-input label="Company" field-name="company" disabled> </text-input>

      <text-input label="Name" field-name="full_name" disabled> </text-input>

      <text-input label="Farm Group Name" field-name="farm_group_name" disabled> </text-input>

      <text-input label="Previous Consult Year" field-name="previous_winter_consult_year" disabled> </text-input>

      <text-input label="Zone" field-name="zone" disabled> </text-input>

      <text-input label="Address" field-name="full_address" disabled> </text-input>

      <text-input label="Phone" field-name="phone" :disabled="isReadOnly"> </text-input>

      <text-input label="Mobile" field-name="mobile" :disabled="isReadOnly"> </text-input>

      <text-input label="E-Mail" field-name="email" :disabled="isReadOnly"> </text-input>

      <select-input
        label="Pref. Contact Method"
        field-name="pref_contact_method"
        :options="[
          { value: 'E-Mail', display: 'E-Mail' },
          { value: 'Mail', display: 'Mail' },
          { value: 'Txt', display: 'Txt' },
          { value: 'Phone', display: 'Phone' },
        ]"
        :disabled="isReadOnly"
      >
      </select-input>

      <text-input label="Keyvets" field-name="vision_keyvets" disabled> </text-input>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'ClientDetails',
  mixins: [baseComponent],
}
</script>
